export enum Client {
  PC = <any>'PC',
  WX = <any>'WX'
}
